export const defaultTeacher = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    password: '',
    comments: '',
    genderType: null, // true = Female, false = Male, null = Prefer not to say
    customerId: null,
}
